import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { odataParamsFactory } from '@tdw/core';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { PigProductGuideService } from 'src/app/services/pig-product-guide.service';
import { PigService } from 'src/app/services/pig-service.service';
import { DefaultDate, IDate } from 'src/app/util/date.interface';

import * as fromPigGuide from '../fromPigProductGuide.barrel';

@Injectable()
export class PigProductGuideEffects {
  constructor(
    private actions$: Actions,
    private guideService: PigProductGuideService,
    private store: Store<fromPigGuide.State>,
    private pigService: PigService,
    private defaultDate: DefaultDate
  ) { }

  loadLookups$ = createEffect(() => this.actions$.pipe(
    ofType(fromPigGuide.loadLookups),
    switchMap(action => this.guideService.getLookups(this.defaultDate)
      .pipe(map(lookups => fromPigGuide.loadLookupsSuccess({ lookups })),
        catchError(error => of(fromPigGuide.loadLookupsFailure({ error })))))));

  loadPigProducts$ = createEffect(() => this.actions$.pipe(
    ofType(fromPigGuide.loadPigProducts, fromPigGuide.goToPage, fromPigGuide.changeFilter, fromPigGuide.clearFilter),
    withLatestFrom(this.store.select(fromPigGuide.selectPigProductOdataParams(this.defaultDate.getDate()))),
    switchMap(([action, q]) => this.guideService.getPigProducts(odataParamsFactory(q))
      .pipe(map(pigProducts => fromPigGuide.loadPigProductsSuccess({ pigProducts: pigProducts || [] })),
        catchError(error => of(fromPigGuide.loadPigProductsFailure({ error }))))
    )
  ));

  downloadPigCutSheet$ = createEffect(() => this.actions$.pipe(
    ofType(fromPigGuide.loadCutSheet),
    switchMap((action) => this.pigService.getPigCutSheet(action.id || -1)
      .pipe(map(file => {
        window.open(URL.createObjectURL(file));
        return fromPigGuide.loadCutSheetSuccess();
      }))),
    catchError(error => of(fromPigGuide.loadCutSheetFailure({ error })))
  ));
}
